import { Typography, Box } from "@mui/material";
import { scoreColor } from "../../utils/scoreColor";

interface Props {
  title: string;
  score: number;
  maxScore?: number;
  round?: boolean;
  reversedColor?: boolean;
}

export function DimensionCard({
  title,
  score,
  maxScore,
  round,
  reversedColor
}: Props) {
  return (
    <Box
      sx={{
        border: '1.5px solid #e0e0e0',
        borderRadius: '12px',
        boxShadow: 'none',
        background: '#fff',
        p: '18px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        minWidth: 120,
        width: '100%',
        height: '100%',
        minHeight: '120px',
      }}
    >
      <Typography
        fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
        fontFamily={"IBM Plex Sans"}
        fontWeight={600}
        color={"#1A237E"}
        sx={{ 
          marginBottom: '8px',
          lineHeight: 1.2,
          wordBreak: 'break-word'
        }}
      >
        {title}
      </Typography>
      <Typography
        fontSize={{ xs: "28px", sm: "30px", md: "32px" }}
        fontFamily={"IBM Plex Sans"}
        fontWeight={600}
        color={
          maxScore !== undefined
            ? !reversedColor
              ? scoreColor(score, maxScore)
              : scoreColor(maxScore - score, maxScore)
            : "#1A237E"
        }
        sx={{ 
          lineHeight: 1,
          marginBottom: '4px'
        }}
      >
        {!score ? 0 : !round ? score.toFixed(2) : score.toFixed(0)}
      </Typography>
    </Box>
  );
}
